import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { ApiShivaService } from '@core/apis/api-shiva.service';
import { IJobResponse, IWorkOrderItems } from '@core/interfaces';
import { SignalsService } from '@core/services/signals.service';

@Injectable({ providedIn: 'root' })
export class ScannedEquipmentExportService {
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public readonly apiShiva = inject(ApiShivaService);
  public readonly signalsService = inject(SignalsService);
  public readonly toastr = inject(ToastrService);

  public triggerExport(workOrderItem: IWorkOrderItems): Promise<void> {
    this.isLoading$.next(true);
    return this.apiShiva.work_order_items.exportScannedEquipment(workOrderItem.id)
      .then((response: IJobResponse): void => {
        this.signalsService.broadcastJobStart(response.job_name, response.job_id);
        this.toastr.success('Demande prise en compte. Veuillez patienter le temps que le fichier d\'export soit généré.');
      })
      .catch(() => {
        this.toastr.error('Echec de la demande d\'export. Veuillez réessayer.');
      })
      .finally(() => this.isLoading$.next(false));
  }
}
